var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62132 10.5L11.5607 2.56066C12.1464 1.97487 12.1464 1.02513 11.5607 0.43934C10.9749 -0.146447 10.0251 -0.146447 9.43934 0.43934L0.43934 9.43934C-0.146447 10.0251 -0.146447 10.9749 0.43934 11.5607L9.43934 20.5607C10.0251 21.1464 10.9749 21.1464 11.5607 20.5607C12.1464 19.9749 12.1464 19.0251 11.5607 18.4393L3.62132 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.5304153dab817f463a2f8508a0a32484.svg";
export { ForwardRef as ReactComponent };